export default "__VITE_ASSET__f1a81670__"